export default {
  title: '產品管理',
  productList: '產品列表',
  addProduct: '新增產品',
  editProduct: '編輯產品',
};
